import { useParams } from "react-router-dom";

const useParamsNumber = (key = "id") => {
  const params = useParams();
  return params[key] ? Number(params[key]) : null;
};

export default useParamsNumber;
